<template>
    <div class="showbox">
        <div class="loader">
            <svg class="circular" viewBox="25 25 50 50">
                <circle
                        class="path"
                        cx="50"
                        cy="50"
                        r="20"
                        fill="none"
                        stroke-width="2"
                        stroke-miterlimit="10"
                />
            </svg>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Loader"
    }
</script>

<style scoped>
    .loader {
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        position: fixed;
    }

    .circular {
        animation: rotate 2s linear infinite;
        height: 100px;
        transform-origin: center center;
        width: 100px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }

    .path {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
        animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
        stroke-linecap: round;
    }

    @keyframes rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes dash {
        0% {
            stroke-dasharray: 1, 200;
            stroke-dashoffset: 0;
        }

        50% {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: -35px;
        }

        100% {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: -124px;
        }
    }

    @keyframes color {
        100%,
        0% {
            stroke: #008f86;
        }

        40% {
            stroke: #008f86;
        }

        66% {
            stroke: #008f86;
        }

        80%,
        90% {
            stroke: #008f86;
        }
    }

    .showbox {
        transition: 0.55s opacity, 0.55s visibility;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 5%;
        z-index: 1000;
        background: #ffffff94;
        height: 100%;
    }
</style>